import React from "react";
import tw from "twin.macro";
import { SectionHeading, Subheading } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import ProductFrame from "components/misc/ProductFrame.js";
import analyticsImage from "images/product/analytics.jpg";

/*
 * Replaces the template "Cloud built by and for Professionals" block, whose
 * image was eight generic cartoon avatars. Shows the real leadership
 * dashboard instead. The claim that reporter identity is never retrieved is
 * verified: the analytics query selects incident metadata only.
 */
const Row = tw.div`flex flex-col lg:flex-row gap-12 lg:gap-16 items-center max-w-screen-xl mx-auto`;
const ImageColumn = tw.div`w-full lg:w-7/12`;
const TextColumn = tw.div`w-full lg:w-5/12`;
const Eyebrow = tw(Subheading)`text-left`;
const Heading = tw(SectionHeading)`text-left mt-2`;
const Description = tw.p`mt-6 text-lg leading-relaxed text-gray-800`;
const List = tw.ul`mt-6 space-y-2 text-gray-800`;
const Item = tw.li`flex gap-3`;
const Dash = tw.span`text-primary-500 font-bold`;
const PrimaryButton = tw(PrimaryButtonBase)`mt-10 inline-block rounded-full px-8 py-4`;

export default () => (
  <Container>
    <ContentWithPaddingXl>
      <Row>
        <ImageColumn>
          <ProductFrame
            src={analyticsImage}
            url="app.ethoshub.io/analytics"
            alt="EthosHub leadership analytics showing monthly case volume as a bar chart."
          />
        </ImageColumn>
        <TextColumn>
          <Eyebrow>For leadership</Eyebrow>
          <Heading>See the patterns. Never the people.</Heading>
          <Description>
            Leadership dashboards turn individual reports into insight you can act on —
            without exposing anyone who came forward.
          </Description>
          <List>
            <Item><Dash aria-hidden="true">—</Dash>Case volume and trends over time</Item>
            <Item><Dash aria-hidden="true">—</Dash>Breakdowns by category, department and location</Item>
            <Item><Dash aria-hidden="true">—</Dash>Resolution times and open-versus-closed ratios</Item>
            <Item><Dash aria-hidden="true">—</Dash>Repeat-subject patterns, with names abbreviated</Item>
          </List>
          <PrimaryButton as="a" href="/contact">Book a demo</PrimaryButton>
        </TextColumn>
      </Row>
    </ContentWithPaddingXl>
  </Container>
);
